import { FC, ReactNode } from 'react'

import * as ReviewModal from './ReviewDetailsModal.styles'

export const ReviewDetailsModal: FC<{
  isOpen: boolean
  onClose(): void
  children: ReactNode | ReactNode[]
}> = ({ isOpen, onClose, children }) => {
  return (
    <ReviewModal.Modal
      open={isOpen}
      onClose={onClose}
      footer={null}
      header={null}
      content={<ReviewModal.ModalContent />}
    >
      {children}
    </ReviewModal.Modal>
  )
}
